import { Injectable } from '@angular/core';
import { UtilsService } from './utils.service';
import { environment } from 'src/environments/environment';
import { ApiUrlService } from 'src/services/api-url.service';
import { FetchService } from './fetch.service';
import { SendOtpResponse } from 'src/app/pages/widget/types/pin/pin.component';
import { PinUtilsService } from 'src/app/pages/widget/types/pin/pin-utils.service';
import { SolicitudesService } from './solicitudes.service';

@Injectable({
    providedIn: 'root'
})
export class ClavePinService {

    firestoreSubscription;

    constructor(public utils: UtilsService, private pinUtils: PinUtilsService, private localFetch: FetchService, private solicitudesService: SolicitudesService, private apiUrlService: ApiUrlService) {

    }

    async getSolicitudes() {
        const response = await this.localFetch.getFetch(this.apiUrlService.baseUrl + '/requests');
        this.solicitudesService.markRequestOpenedIfNeeded(response);

        return response;
    }

    async getSolicitudByCode(vcCode) {
        const response = await this.localFetch.freeGetFetch(this.apiUrlService.baseUrl + '/requests/' + vcCode);
        this.solicitudesService.markRequestOpenedIfNeeded(response);

        return response;
    }

    noMatchPhone(obj) {
        return new Promise((resolve, reject) => {
            this.localFetch.postFetchWhitoutToken(this.apiUrlService.baseUrl + '/requests/clave-pin/cancel', obj).then(d => {
                this.pinUtils.sendMessageToParent({ type: "response", data: d.data || d });
                if(d) {
                    resolve(d);
                } else {
                    reject(d)
                }
            }).catch(e => {
                this.pinUtils.sendMessageToParent({ type: "response", data: e.data || e });
                reject(e);
            })
        });

    }

    addSolicitud(obj) {
        return new Promise((resolve, reject) => {
            this.localFetch.postFetchWhitoutToken(this.apiUrlService.baseUrl + '/requests/clave-pin', obj).then(response => {
                this.pinUtils.sendMessageToParent({ type: "response", data: response.data || response });
                if(response) {
                    this.solicitudesService.markRequestOpenedIfNeeded(response);
                    resolve(response);
                } else {
                    reject(response)
                }
            }).catch(e => {
                this.pinUtils.sendMessageToParent({ type: "response", data: e.data || e });
                reject(e);
            })
        });
    }

    checkService(obj) {
        return new Promise((resolve, reject) => {
            this.localFetch.postFetchWhitoutToken(this.apiUrlService.baseUrl + '/requests/clave-pin/check-service', obj).then(d => {
              if (d.code === 400) {
                this.pinUtils.sendMessageToParent({ type: "response", data: {...d.response, status_code: 'no_clave_pin_service'} });
              } else {
                this.pinUtils.sendMessageToParent({ type: "response", data: d.data || d })
              }
              resolve(d);
            }).catch(e => {
                this.pinUtils.sendMessageToParent({ type: "response", data: e.data || e });
                reject(e);
            })
        });
    }

    setNoService(obj) {
        return new Promise((resolve, reject) => {
            this.localFetch.postFetchWhitoutToken(this.apiUrlService.baseUrl + '/requests/clave-pin/no-service', obj).then(d => {
                this.pinUtils.sendMessageToParent({ type: "response", data: d.data || d });
                if(d) {
                    resolve(d);
                } else {
                    reject(d)
                }
            }).catch(e => {
                this.pinUtils.sendMessageToParent({ type: "response", data: e.data || e });
                reject(e);
            })
        });

    }

    acceptTerms(obj) {
        return new Promise((resolve, reject) => {
            this.localFetch.postFetchWhitoutToken(this.apiUrlService.baseUrl + '/requests/clave-pin/terms', obj).then(d => {
                this.pinUtils.sendMessageToParent({ type: "response", data: d.data || d });
                if(d) {
                    resolve(d);
                } else {
                    reject(d)
                }
            }).catch(e => {
                this.pinUtils.sendMessageToParent({ type: "response", data: e.data || e });
                reject(e);
            })
        });
    }

    getNewIdOfRequest(id) {
        return new Promise((resolve, reject) => {
            this.localFetch.postFetchWhitoutToken(this.apiUrlService.baseUrl + '/requests/' + id + '/get-new-id', {}).then(d => {
                this.pinUtils.sendMessageToParent({ type: "response", data: d.data || d });
                if(d) {
                    resolve(d);
                } else {
                    reject(d)
                }
            }).catch(e => {
                this.pinUtils.sendMessageToParent({ type: "response", data: e.data || e });
                reject(e);
            })
        });
    }

    retryRequest(obj) {
        return new Promise((resolve, reject) => {
            this.localFetch.postFetchWhitoutToken(this.apiUrlService.baseUrl + '/requests/clave-pin/retry', obj).then(d => {
                this.pinUtils.sendMessageToParent({ type: "response", data: d.data || d });
                if(d) {
                    resolve(d);
                } else {
                    reject(d)
                }
            }).catch(e => {
                this.pinUtils.sendMessageToParent({ type: "response", data: e.data || e });
                reject(e);
            })
        });
    }

    resendOTP(obj) {
        return new Promise((resolve, reject) => {
            this.localFetch.postFetchWhitoutToken(this.apiUrlService.baseUrl + '/requests/clave-pin/resend-otp', obj).then(d => {
                this.pinUtils.sendMessageToParent({ type: "response", data: d.data || d });
                if(d) {
                    resolve(d);
                } else {
                    reject(d)
                }
            }).catch(e => {
                this.pinUtils.sendMessageToParent({ type: "response", data: e.data || e });
                reject(e);
            })
        });
    }

    fixData(request_id, obj) {
        return new Promise((resolve, reject) => {
            this.localFetch.putFetchWhitoutToken(`${this.apiUrlService.baseUrl}/requests/${request_id}/person`, obj).then(d => {
                this.pinUtils.sendMessageToParent({ type: "response", data: d.data || d });
                if(d) {
                    resolve(d);
                } else {
                    reject(d)
                }
            }).catch(e => {
                this.pinUtils.sendMessageToParent({ type: "response", data: e.data || e });
                reject(e);
            })
        });
    }

    sendOTP(obj, isMock?): Promise<SendOtpResponse> {
        let url = '/requests/clave-pin/otp';
        if(environment['scraperMock'] || isMock) {
            url = '/mockscrapper/requests/clave-pin/otp';
        }
        return new Promise((resolve, reject) => {
            this.localFetch.postFetchWhitoutToken(this.apiUrlService.baseUrl + url, obj).then(d => {
                this.pinUtils.sendMessageToParent({ type: "response", data: d.data || d });
                if(d) {
                    resolve(d);
                } else {
                    reject(d)
                }
            }).catch(e => {
                this.pinUtils.sendMessageToParent({ type: "response", data: e.data || e });
                reject(e);
            })
        });
    }

    sendOTPToBde(obj, isMock?) {
        let url = '/requests/cirbe-cp/otp';
        if(environment['scraperMock'] || isMock) {
            url = '/mockscrapper/requests/cirbe-cp/otp';
        }
        return new Promise((resolve, reject) => {
            this.localFetch.postFetchWhitoutToken(this.apiUrlService.baseUrl + url, obj).then(d => {
                this.pinUtils.sendMessageToParent({ type: "response", data: d.data || d });
                if(d) {
                    resolve(d);
                } else {
                    reject(d)
                }
            }).catch(e => {
                this.pinUtils.sendMessageToParent({ type: "response", data: e.data || e });
                reject(e);
            })
        });
    }

    sendSecondTask(obj) {
        let url = '/requests/clave-pin/secondTask';
        if(environment['scraperMock']) {
            url = '/mockscrapper/requests/clave-pin/secondTask'
        }
        return new Promise((resolve, reject) => {
            this.localFetch.postFetchWhitoutToken(this.apiUrlService.baseUrl + url, obj).then(d => {
                this.pinUtils.sendMessageToParent({ type: "response", data: d.data || d });
                if(d) {
                    resolve(d);
                } else {
                    reject(d)
                }
            }).catch(e => {
                this.pinUtils.sendMessageToParent({ type: "response", data: e.data || e });
                reject(e);
            })
        });
    }

    sendLinkBySms(requestID, obj) {
        return new Promise((resolve, reject) => {
            this.localFetch.postFetch(`${this.apiUrlService.baseUrl}/requests/${requestID}/send-link-sms`, obj).then(d => {
                this.pinUtils.sendMessageToParent({ type: "response", data: d.data || d });
                if(d) {
                    resolve(d);
                } else {
                    reject(d)
                }
            }).catch(e => {
                this.pinUtils.sendMessageToParent({ type: "response", data: e.data || e });
                reject(e);
            })
        });
    }
}
